import { render, staticRenderFns } from "./CabinetLayout.vue?vue&type=template&id=5c41b754&lang=pug&"
import script from "./CabinetLayout.vue?vue&type=script&lang=js&"
export * from "./CabinetLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports